import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { AnimatePresence, motion } from 'framer-motion';
import Iridescence from '../components/Iridescence';

const MainLayout: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    // Outer container: relative + full height
    <div className="relative flex flex-col min-h-screen overflow-hidden">
      {/* Iridescence Background - Full screen, fixed, behind everything */}
      <Iridescence
        color={[1, 1, 1]}
        mouseReact={false}
        amplitude={0.1}
        speed={1.0}
        style={{ position: "fixed", inset: 0, zIndex: -10, pointerEvents: "none" }}
      />

      {/* Optional: Semi-transparent overlay to improve text readability */}
      {/* Remove or adjust opacity if your content is already readable */}
      <div className="fixed inset-0 -z-10 bg-black/20 pointer-events-none" />

      {/* Your actual content - on top of the background */}
      <div className="relative z-10 flex flex-col min-h-screen">
        {/* Remove your old bg-gradient here - it was hiding the iridescence */}
        <Navbar scrolled={scrolled} />

        <main className="flex-grow">
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
              className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12"
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;